import React from "react";
import { useCashAvailable } from "@/hooks/firestore/user/useAccountBalances";
import { useGameSessions } from "@/features/casino/hooks/useGameSessions";
import { constructCurrency } from "common/currency";
import { PillNotice } from "@picklebet/ui";

type AvailableBalancePillNoticeProps = {
  offsetTopAvailable?: string;
  offsetRightAvailable?: string;
  offsetTopPromo?: string;
  offsetRightPromo?: string;
};

const AvailableBalancePillNotice = ({
  offsetTopAvailable = "-1.4375rem",
  offsetRightAvailable = "0.625rem",
  offsetTopPromo = "0.375rem",
  offsetRightPromo = "0.625rem",
}: AvailableBalancePillNoticeProps) => {
  const {
    available,
    currency,
    isLoading: isLoadingCashAvailable,
    promo,
  } = useCashAvailable();

  const { hasActiveGameSession, isLoading: isLoadingGameSessions } =
    useGameSessions(true);

  const formatCurrency = (v: number) =>
    constructCurrency(v, {
      currencyType: currency,
      showDecimals: "IF_REQUIRED",
      showCurrencySymbol: true,
    });

  return !hasActiveGameSession && !isLoadingGameSessions ? (
    <>
      <PillNotice
        value={available}
        offsetTop={offsetTopAvailable}
        offsetRight={offsetRightAvailable}
        formatValue={formatCurrency}
        isLoading={isLoadingCashAvailable}
      />
      <PillNotice
        value={promo}
        variant="promo"
        direction="DOWN"
        offsetTop={offsetTopPromo}
        offsetRight={offsetRightPromo}
        formatValue={formatCurrency}
        isLoading={isLoadingCashAvailable}
      />
    </>
  ) : null;
};

export default AvailableBalancePillNotice;
